import React from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, title, message, confirmText, cancelText, onConfirm, type = 'info' }) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm && onConfirm();
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className={`modal-header ${type}`}>
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          {cancelText && (
            <button className="modal-button cancel-button" onClick={onClose}>
              {cancelText}
            </button>
          )}
          <button 
            className={`modal-button ${type === 'error' ? 'error-button' : type === 'warning' ? 'warning-button' : 'confirm-button'}`} 
            onClick={handleConfirm}
          >
            {confirmText || 'OK'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;